// HUMAN LABELS FOR A LEAD'S SOURCE. The stored code never changes (filters, the API and the lead doc all carry the code); this is
// the one place a code becomes words for a person. An unknown code is made readable ("tiktok_ads" -> "Tiktok ads"), never hidden.

const LABELS: Record<string, string> = {
  meta_lead_form: 'Meta lead form',
  website: 'Website',
  phone: 'Phone call',
  google: 'Google',
  google_ads: 'Google',
};

export function sourceLabel(code: string | null | undefined): string {
  const c = (code ?? '').trim();
  if (c === '') return 'Unknown';
  const known = LABELS[c.toLowerCase()];
  if (known) return known;
  const words = c.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
